import React, { PureComponent, Fragment } from 'react';
import * as RBT from 'react-bootstrap';
import classnames from 'classnames';
import validateUserChangePassword from '../../../Validations/userChangePassword';
import AlertWrapper from '../../Common/AlertWrapper';
import AlertWrapperSuccess from '../../Common/AlertWrapperSuccess';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../../Store/actions/loginActions';
import { AJAX_REQUEST, sentryErrorLog } from '../../../Constants/AppConstants';

class ChangePassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            action_btn_label: false,
            changePasswordModalShow: false,
            current_password: "",
            new_password: "",
            confirm_new_password: "",

            errors: {},
            isValid: false,
            isLoading: false,
            isFormValid: true,
            server_message: ''
        }
    }

    componentDidMount() {
        //
    }

    //change password modal
    changePasswordModal = (visibleStatus) => {
        this.setState({
            changePasswordModalShow: visibleStatus,
            errors: {},
            isValid: false,
            isLoading: false,
            isFormValid: true,
            server_message: ''
        });
    };

    changeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    timeOut = (timedata) => {
        setTimeout(function () {
            this.setState({
                changePasswordModalShow: false,
                success_alert_wrapper_show: false,
                server_message: ''
            });
        }.bind(this), timedata);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ action_btn_label: true })

        const val_return = validateUserChangePassword(this.state);
        this.setState(val_return);

        if (val_return.isValid) {
            this.setState({ errors: {}, isLoading: true });

            AJAX_REQUEST("POST", "operator/change_password", this.state).then(results => {

                // Sentry Log create
                sentryErrorLog(results);

                const response = results.response;
                if (parseInt(response.code) === 1000) {
                    this.setState({
                        current_password: "",
                        new_password: "",
                        confirm_new_password: "",
                        server_message: response.message,
                        isFormValid: true,
                        isLoading: false,
                        success_alert_wrapper_show: true,
                        action_btn_label: false
                    });
                    this.timeOut(5000);
                } else {
                    this.setState({
                        server_message: response.message,
                        isFormValid: false,
                        isLoading: false,
                        success_alert_wrapper_show: false,
                        action_btn_label: false
                    });
                }
            });
        } else {
            this.setState({ action_btn_label: false });
        }
    }

    render() {
        const { errors, server_message, success_alert_wrapper_show } = this.state;
        const errors_data = server_message;

        return (
            <Fragment>
                <li className="change-password-modal"> <button className="nav-link" onClick={() => this.changePasswordModal(true)}>Change Password</button></li>

                {/*--Start Change Password Modal --*/}
                <RBT.Modal className="live-chat-modal change-password-modal" centered show={this.state.changePasswordModalShow} onHide={() => this.changePasswordModal(false)} >
                    <RBT.Modal.Header closeButton>
                        <RBT.Modal.Title>Change Password</RBT.Modal.Title>
                    </RBT.Modal.Header>
                    <RBT.Modal.Body>
                        <div className="">
                            <form onSubmit={this.onSubmit} method="post" style={{ border: '0' }} className="edit_account_form action_form" encType="multipart/form-data">
                                <AlertWrapper errors_data={errors_data} isFormValid={this.state.isFormValid} />
                                <AlertWrapperSuccess errors_data={errors_data} success_alert_wrapper_show={success_alert_wrapper_show} />

                                <div className="form-group">
                                    <label className={classnames(null, { 'pl_error_label': errors.current_password })} htmlFor="current_password">Current Password<span className="required">*</span></label>
                                    <input onChange={this.changeHandler} type="password" className={classnames("cus_field", { 'pl_error_input': errors.current_password })} name="current_password" id="current_password" placeholder="Old Password" />
                                </div>
                                <div className="form-group">
                                    <label className={classnames(null, { 'pl_error_label': errors.new_password })} htmlFor="new_password">New Password<span className="required">*</span></label>
                                    <input onChange={this.changeHandler} type="password" className={classnames("cus_field", { 'pl_error_input': errors.new_password })} name="new_password" id="new_password" placeholder="New Password" />
                                </div>
                                <div className="form-group">
                                    <label className={classnames(null, { 'pl_error_label': errors.confirm_new_password })} htmlFor="confirm_new_password">Confirm New Password<span className="required">*</span></label>
                                    <input onChange={this.changeHandler} type="password" className={classnames("cus_field", { 'pl_error_input': errors.confirm_new_password })} name="confirm_new_password" id="confirm_new_password" placeholder="Confirm Password" />
                                </div>
                                <div className="">
                                    <button type="submit" disabled={this.state.isLoading} className="roboto_condensed cus_button" name="login" value="Login"> {this.state.action_btn_label ? "Saving..." : "Save Changes"} </button>
                                </div>
                            </form>
                        </div>
                    </RBT.Modal.Body>
                </RBT.Modal>
                {/*--End change Password Modal --*/}

            </Fragment>
        );
    }
}

ChangePassword.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { logout })(ChangePassword);